import React from "react";
import "./PricingCard.scss";

const PricingCard = ({
  type,
  title,
  originalPrice,
  price,
  pricePeriod = "month",
  discountPercent,
  validity,
  gradientFrom,
  buttonColor,
  onClick,
}) => {

  const getPopularBadge = () => {
    if (type === "popular") {
      return <div className="popular-badge">Most Popular</div>;
    }
    return null;
  };

  return (
    <div className={`pricing-card ${type} ${gradientFrom}`}>
            {type === 'trial' && (
        <div className="badge trial">
          <span>FREE</span>
        </div>
      )}
      {type === 'popular' && (
        <div className="badge popular">
          <span>POPULAR</span>
        </div>
      )}
      <div className="pricing-content">
        <h3 className="title">{title}</h3>
        <div className="price">
          {originalPrice &&  (
            <p className="original-price">₹{originalPrice.toLocaleString('en-IN')}</p>
          )}
          <span className="current-price">₹{price.toLocaleString('en-IN')}</span>
          {price > 0 && <span className="period">/{pricePeriod}</span>}
          {discountPercent > 0 && (
            <div className="discount">({discountPercent}% off)</div>
          )}
        </div>
        {price > 0 && <p className="tax">(+ GST)</p>}
        <p className="period">Validity - {validity}</p>
      </div>

      <button className={`action-button ${buttonColor}`} onClick={onClick}>
        {type === "trial" ? "Start Trial" : "Buy this Plan"}
      </button>
    </div>
  );
};

export default PricingCard;
